/* eslint-disable */
import axios from '@/services/axios'

export default {
    list(search) {
        return axios.get("/mmp-tracking/search", {
            params: search
        });
    },
    get(sq) {
        return axios.get(`/mmp-tracking/get/${sq}`);
    },
    create(data) {
        return axios.post("/mmp-tracking/create", data);
    },
    update(data) {
        return axios.post("/mmp-tracking/update", data);
    },
    delete(sq) {
        return axios.delete(`/mmp-tracking/delete/${sq}`);
    },
    resign(id) {
        return axios.post(`/mmp-tracking/resign`, {id});
    }
};